import { authGuard } from '@/features/auth/guards/authGuard.js'
import { sessionGuard } from '@/features/auth/guards/sessionGuard.js'
import { clubRegisteredGuard } from '@/features/router/guards/clubRegisteredGuard.js'
import { trackingForProfileRoutes } from '@/features/tracking/trackingForProfile/trackingForProfileRoutes.js'
import DummyRouter from '@/features/ui/components/DummyRouter.vue'

const commonGuard = [authGuard, sessionGuard, clubRegisteredGuard]

export const clubLandingRoutes = [
  {
    path: '',
    component: () => import('./ClubLandingHomeView.vue'),
  },
  {
    path: 'landing',
    component: DummyRouter,
    beforeEnter: commonGuard,
    children: [
      {
        path: '',
        component: () => import('./clubLandingHome/ClubLandingHomeLoggedView.vue'),
        children: [
          {
            path: '',
            component: () => import('./clubLandingHome/ClubLandingHomeLoggedViewMemberships.vue'),
          },
          {
            path: 'profile',
            component: () => import('./clubLandingProfile/ClubLandingProfileView.vue'),
          },
        ],
      },
      {
        path: 'events',
        component: DummyRouter,
        children: [
          {
            path: '',
            component: () =>
              import('@/features/eventManagement/views/public/EventResponsePublicAuthLayout.vue'),
            children: [
              {
                path: 'response',
                component: () =>
                  import('@/features/eventManagement/views/public/onboard/EventResponsePublicOnboard.vue'),
              },
            ],
          },
        ],
      },
    ],
  },

  ...trackingForProfileRoutes(commonGuard),
]
